/*
 * @Author: fangchutao
 * @Description: 合同多语言配置包
 * @Date: 2019-08-26 16:58:06
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-15 14:49:08
 */
export default {
  '云POS模块价格说明': '',
  '功能模块': '',
  '配置化模块': '',
  'SAAS租用': '',
  '购买': '',
  '云POS硬件支持情况': '',
  '物流模块': '',
  '基础物流模块': '',
  'O2O物流模块': '',
  '365/年': '',
  '199/年': '',
  '600元+100元综合维护费/年': '',
  '200元+100元综合维护费/年': '',
  '收银模块': '',
  '云POS（物流+收银）': '',
  '730/年': '',
  '1200元+200元综合维护费/年': '',
  '900/年': '',
  '1400元+200元综合维护费/年': '',
  '联系我们': 'About Us',
  '总部:': '',
  '地址': 'Address',
  '电话': 'Mobile',
  '邮箱': 'Email',
  '客服中心:': '',
  '犀牛EPOS · PC版': 'Xiniu EPOS·PC Download',
  '全新上线，给你最美、最流畅的店铺Pos体验': 'Brand new, giving you the most beautiful and smooth shop Pos experience',
  '下载最新版': 'Download Newest Version',
  '运行环境：Win7或更高版本': 'Operating Environment：Win7 or Higher',
  '品牌Webpos下载': '',
  '下载最新定制版': 'Download Newest',
  '更多': 'More',
  '历史版本': ' Version History',
  '下载该版本': ' Download',
  '收银': 'Sell',
  '物流': 'In&Out',
  '报表': 'Repor',
  '查会员': 'Search  VIP',
  '犀牛EPOS': 'Xiniu EPOS',
  '产品': 'Software',
  '客户': 'Customer',
  'PC版下载': 'webPos',
  '移动版下载': 'APP',
  '智慧零售 赋能门店': 'Smart Retail Empowered Stores',
  '为您提供新零售所需要的一切': 'All New Retail You Need',
  '销售退换货': 'Sales & Return',
  '预售/赠送': 'Presale/Give Gift',
  '流行促销': 'Promotion',
  '会员/积分': 'VIP/Points',
  '储值/券': 'Value/Coupon',
  '收发货': 'Ship%Delevery',
  '盘点': 'Stock Check',
  '电商发货/退货': 'E-commerce Delivery',
  '真正的移动收银神器': 'Real Mobile Cashier Artifact',
  '商米/PDA/平板/手机': 'SUNMI/PDA/PAD/Mobile',
  '专为服饰零售行业客户而生': 'Built For Customers In The Apparel Retail Industry',
  '广州丽晶软件科技股份有限公司致力做最杰出的服饰管理专家，着意创建先进、精简、实用高效的电脑信息管理系统，用专注、创新见证着中国服装产业信息化发展进程。丽晶不仅仅要让企业在标准化的行业体系之中占有一席之地，达到灵活调度企业资源，快速感知市场变化，准确规划运营策略，实现销售增长的目的，更要竭尽全力增强服饰企业本身的独特竞争力，指引应用者凭添果敢的能力，激发决策者闪现睿智的灵感，在现在和未来发展与竞争中不断超越！': 'Guangzhou Regent Software Technology Co., Ltd. is committed to being the most outstanding clothing management expert. It is committed to creating advanced, streamlined, practical and efficient computer information management systems. It has witnessed the development of China\'s clothing industry informatization with focus and innovation. Regent must not only allow enterprises to occupy a place in the standardized industry system, to achieve flexible scheduling of corporate resources, rapid perception of market changes, accurate planning of operating strategies, and sales growth, but also to make every effort to enhance the unique competition of apparel companies themselves Power, guide users to rely on the ability to add courage, inspire decision-makers to show wise inspiration, and continue to surpass in the development and competition now and in the future!',
  '下载': 'Download',
  '全国热线': 'National Hotline',
  '周一至周五 9:00-18:00': 'Monday to Friday 9:00-18:00',
  '公司邮箱': 'Company Email',
  '粤ICP备12071402号-7': '',
  '粤ICP备12071402号': '粤ICP备12071402号',
  '扫码下载，货品管理尽在掌中': 'Scan Code to Download,Goods Management in the Hand',
  '安卓平板下载': 'pad',
  '安卓手机下载': 'Android Mobile',
  'iPhone下载': 'iPhone',
  'iPad下载': 'ipad',
  '品牌订制下载': 'Custom Download',
  '关于我们': 'About Us',
  '总部': '',
  '传真': 'FAX',
  '点击下载': 'Download',
  '企业后台登录': 'Company Background ',
  '运营管理后台': 'Operation Background',
  '犀牛EPOS · 定制版': 'Xiniu EPOS  · Custom',
  '移动端': '',
  '安卓手机': 'Android Mobile',
  '安卓平板': 'Android PAD',
  '定制版下载': 'Custom Download',
  '南京市中山东路18号国际贸易中心12层C3座': 'Block C3, 12 / F, International Trade Center, 18 Zhongshan East Road, Nanjing',
  '广州番禺区番禺大道北555号天安节能科技园15号楼102': 'Room 102, Building 15, Tianan Energy-saving Science and Technology Park, No. 555 Panyu Avenue North, Panyu District, Guangzhou'
}


// WEBPACK FOOTER //
// ./src/i18n/en/home.js